import { ForgeSlider } from '@tylertech/forge-react';
import React from 'react';
import PropTypes from 'prop-types';

const BoundaryRow = ({ label, min, max = 1, startLabel, endLabel, disabled, startValue, endValue, onForgeSliderRangeChange, onChange, range = false, value, name = '', step = max * 0.001  }) => {
  return (
    <div className="slider">
      <div className="forge-typography--body1">{label}</div>
      <ForgeSlider
        name={name}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        labelStart={startLabel}
        labelEnd={endLabel}
        valueStart={startValue}
        valueEnd={endValue}
        on-forge-slider-range-change={onForgeSliderRangeChange}
        range={range}
        value={value}
        data-aria-label-start="Start"
        data-aria-label-end="End"
        className="tyler-slider"
        on-forge-slider-change={onChange}
      />
    </div>
  );
};

BoundaryRow.propTypes = {
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  disabled: PropTypes.bool,
  startValue: PropTypes.number,
  endValue: PropTypes.number,
  onForgeSliderRangeChange: PropTypes.func,
  onChange: PropTypes.func,
  range: PropTypes.bool,
  value: PropTypes.number,
  name: PropTypes.string,
  step: PropTypes.number
};

export default BoundaryRow;
